import { Unit } from '@/@types/unit';
import { Modal } from '@/components/common';
import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, LinearProgress } from '@mui/material';
import { UnitForm, UnitFormData } from '../UnitForm';
import { UnitFormPlaceholder } from '../UnitForm/UnitFormPlaceholder';

interface IUnitModalProps {
  unit?: Unit;
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: UnitFormData) => void;
}

export function UnitModal({
  unit,
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  isSubmitting,
}: IUnitModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="scroll-dialog-title" sx={{ p: 2 }}>
        {unit ? 'Alterar Unidade' : 'Nova Unidade'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting ? <LinearProgress /> : null}
      {isLoading ? (
        <UnitFormPlaceholder />
      ) : (
        <UnitForm
          unit={unit}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
